import { create } from 'zustand';
import { Editor } from '@tldraw/editor';
import { combine } from 'zustand/middleware';

interface BoardState {
  editor: Editor | null;
  currentUserEditor: Editor | null;
}

interface BoardActions {
  setEditor: (editor: Editor | null) => void;
  setCurrentUserEditor: (editor: Editor | null) => void;
}

export const useBoardStore = create(
  combine<BoardState, BoardActions>(
    {
      editor: null,
      currentUserEditor: null
    },
    (set) => ({
      setEditor: (editor) => set({ editor }),
      setCurrentUserEditor: (editor) => set({ currentUserEditor: editor })
    })
  )
);
